// extracted by mini-css-extract-plugin
export default {"agreementText":"AgreementTextV6_agreementText-Rju"};